import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import BootstrapVue from "bootstrap-vue";
import Vuelidate from "vuelidate";
import Notifications from "vue-notification";
import VueSweetalert2 from "vue-sweetalert2";
import ToggleButton from "vue-js-toggle-button";
import "datatables.net/js/jquery.dataTables";
import "datatables.net-bs4/js/dataTables.bootstrap4";

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.use(Notifications);
Vue.use(VueSweetalert2);
Vue.use(ToggleButton);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
